export default __webpack_public_path__ + "static/media/edit.7496a24e.svg";